/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import {
    SimCardServiceItemConfiguration,
    SimCardServiceTypeConfigurationGet,
    SimCardServiceTypeConfigurationPost,
    SimCardServiceTypeConfigurationPut,
    SimCardServiceTypeItem,
} from '../../../../../interfaces/collections/SimCardServiceInterface';
import Card from '../../../../../components/Card/Card';
import CardBody from '../../../../../components/Card/CardBody';
import CardHeader from '../../../../../components/Heading/CardHeaderExt';
import { Build } from '@material-ui/icons';
import GridContainer from '../../../../../components/Grid/GridContainer';
import GridItem from '../../../../../components/Grid/GridItem';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../../../components/Translate/I18n';
import { roles, UserRoleHelper } from '../../../../../helpers/UserRoleHelper';
import CustomTextButtom from '../../../../../components/Buttons/CustomTextButton';
import { OplSimCardServiceTypeServiceBosSmsMsgEdit } from './OplSimCardServiceTypeServiceBosSmsMsgEdit';
import { PARAM_080X_BARRING_ON } from '../../../../../modules/features/SmsRequestTemplateType';

type OplSimCardServiceTypeServiceBosSmsMsgType = {
    simCardServiceType: SimCardServiceTypeItem;
    languageName: string;
    simCardServiceTypeConfiguration: SimCardServiceTypeConfigurationGet | SimCardServiceTypeConfigurationPost | SimCardServiceTypeConfigurationPut;
    isPost: boolean;
    languageId?: number | null;
    id?: string | null;
    reloadConfiguration: () => void;
    platformResellerId: number;
};

export const OplSimCardServiceTypeServiceBosSmsMsg: FunctionComponent<OplSimCardServiceTypeServiceBosSmsMsgType> = ({
    simCardServiceTypeConfiguration,
    simCardServiceType,
    languageName,
    isPost,
    languageId,
    id,
    reloadConfiguration,
    platformResellerId,
}): ReactElement => {
    const [configuration, setConfiguration] = useState<SimCardServiceItemConfiguration>(JSON.parse(simCardServiceTypeConfiguration.configuration));
    const [edit, setEdit] = useState(false);
    const editComponent = (): void => setEdit(true);

    return (
        <Card>
            <CardHeader
                icon={<Build />}
                trans="prov:feature.sms_message_configure_with_language"
                transValueObject={{ language: languageName.toUpperCase() }}
            />
            <CardBody>
                <GridContainer>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.service_bos_7XXX_BARRING_on" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PARAM_7XXX_BARRING_ON ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PARAM_7XXX_BARRING_ON_MSG}</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.service_bos_7XXX_BARRING_off" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PARAM_7XXX_BARRING_OFF ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PARAM_7XXX_BARRING_OFF_MSG}</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.service_bos_080X_BARRING_on" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PARAM_080X_BARRING_ON ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PARAM_080X_BARRING_ON_MSG}</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.service_bos_080X_BARRING_off" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PARAM_080X_BARRING_OFF ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PARAM_080X_BARRING_OFF_MSG}</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.service_bos_070X_BARRING_on" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PARAM_070X_BARRING_ON ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PARAM_070X_BARRING_ON_MSG}</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.service_bos_070X_BARRING_off" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PARAM_070X_BARRING_OFF ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PARAM_070X_BARRING_OFF_MSG}</Typography>
                    </GridItem>
                    {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PUT) && (
                        <GridItem xs={12} style={{ textAlign: 'right' }}>
                            <CustomTextButtom callback={editComponent} label="general:common.edit" size="sm" />
                        </GridItem>
                    )}
                </GridContainer>
                <OplSimCardServiceTypeServiceBosSmsMsgEdit
                    open={edit}
                    reload={reloadConfiguration}
                    simCardServiceType={simCardServiceType}
                    close={(): void => setEdit(false)}
                    simCardServiceTypeConfiguration={simCardServiceTypeConfiguration}
                    languageName={languageName}
                    isPost={isPost}
                    id={id}
                    languageId={languageId}
                    platformResellerId={platformResellerId}
                />
            </CardBody>
        </Card>
    );
};
